import React from "react";
import GenericAdminCRUD from "../components/GenericAdminCRUD";

export default function ClientNPSEditor() {
  return (
    <GenericAdminCRUD
      title="Pesquisas NPS"
      subtitle="Crie pesquisas NPS por cliente e/ou campanha. Quando abertas, aparecem piscando no dashboard do cliente com botão 'Responder pesquisa'."
      path="client-nps"
      fields={[
        { key: "client_id", label: "Cliente *", type: "clientSelect" },
        { key: "campaign_id", label: "Campanha (opcional)", type: "campaignSelect" },
        { key: "title", label: "Título da pesquisa", type: "text" },
        { key: "subtitle", label: "Descrição curta", type: "text" },
        { key: "status", label: "Status", type: "select", options: [{ value: "open", label: "Aberta" }, { value: "closed", label: "Fechada" }] },
      ]}
      columns={[
        { key: "title", label: "Pesquisa" },
        { key: "campaign_id", label: "Campanha", render: (it, { campaigns }) => campaigns.find((c) => c.id === it.campaign_id)?.name || "Geral" },
        { key: "status", label: "Status" },
        { key: "score", label: "Nota", render: (it) => it.responded ? it.score : "—" },
        { key: "responded", label: "Respondida", render: (it) => it.responded ? "Sim" : "Não" },
      ]}
    />
  );
}
